"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonOrLink = _interopRequireDefault(require("../private/ButtonOrLink"));
var _IconExternalLink = _interopRequireDefault(require("../../icons/General/IconExternalLink"));
var _styles = require("./styles");
var _reactAria = require("react-aria");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Link = props => {
  const {
    disabled,
    children,
    nostyle,
    external,
    danger,
    target,
    nopadding,
    small,
    removeUnderline,
    textAlign = 'center',
    wordBreak,
    ...restProps
  } = props;
  return (0, _jsxRuntime.jsx)(_ButtonOrLink.default, {
    ...restProps,
    disabled: disabled,
    css: theme => [nostyle ? _styles.NoStyle : _styles.LinkStyle, danger && (0, _styles.dangerStyles)(theme), disabled && (0, _styles.setDisabled)(theme), nopadding && _styles.noPadding, (0, _styles.setAlign)(textAlign), small && _styles.smallText, removeUnderline && _styles.underlineNone, wordBreak && (0, _styles.setWordBreak)(wordBreak)],
    ...(target && {
      target
    }),
    children: external ? (0, _jsxRuntime.jsxs)(_styles.IconLinkWrapper, {
      children: [(0, _jsxRuntime.jsx)("span", {
        children: children
      }), (0, _jsxRuntime.jsx)(_IconExternalLink.default, {
        size: "15px",
        color: "blue",
        "aria-hidden": true
      }), (0, _jsxRuntime.jsx)(_reactAria.VisuallyHidden, {
        children: "(\xC5pnes i et nytt vindu)"
      })]
    }) : children
  });
};
var _default = exports.default = Link;